import React from 'react';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { Smile, Users, MapPin, Star } from 'lucide-react';
import './AboutPage.css';

const AboutPage = () => {
  return (
    <div className="about-wrapper">
      {/* Hero Section */}
      <section className="about-hero d-flex align-items-center justify-content-center">
        <div className="text-center text-white hero-text">
          <h1 className="display-4 fw-bold">Your Gateway to Tranquility in Kodaikanal</h1>
          <p className="lead">Comfort. Adventure. Unforgettable Memories.</p>
          <Button variant="light" size="lg" className="rounded-pill fw-bold" as={Link} to="/rooms">Book Now</Button>
        </div>
      </section>

      {/* Welcome Section */}
      <Container className="pt-5">
        <h2 className="section-title mb-4">Welcome to Kabili Holidays</h2>
        <p>
          At Kabili Holidays, we offer an enchanting blend of comfort, serenity, and adventure amidst the breathtaking landscapes of Kodaikanal, Tamil Nadu. Whether you're seeking a cozy homestay, a scenic cottage, or an immersive travel experience, we are here to make your holiday truly unforgettable.
        </p>
        <p>
          Located in the heart of Kodaikanal, Kabili Holidays is more than just a stay – it's a sanctuary where you can disconnect from the hustle and bustle of everyday life and reconnect with nature. With a deep-rooted passion for hospitality, we strive to ensure every guest leaves with cherished memories.
        </p>
      </Container>

      {/* Why Choose Us */}
      <section className="about-section py-5 bg-light">
        <Container>
          <h2 className="section-title text-center mb-4">Why Choose Kabili Holidays</h2>
          <Row className="g-4">
            <Col md={4}>
              <Card className="about-card text-center p-4">
                <MapPin size={40} className="mb-3 text-success" />
                <h5>Prime Location</h5>
                <p>Perfectly nestled amidst the scenic views of Kodaikanal's natural beauty.</p>
              </Card>
            </Col>
            <Col md={4}>
              <Card className="about-card text-center p-4">
                <Smile size={40} className="mb-3 text-warning" />
                <h5>Warm Hospitality</h5>
                <p>Our team is dedicated to creating comfortable, personalized experiences.</p>
              </Card>
            </Col>
            <Col md={4}>
              <Card className="about-card text-center p-4">
                <Users size={40} className="mb-3 text-primary" />
                <h5>Family Friendly</h5>
                <p>Perfect for couples, families, and solo travelers seeking peace or adventure.</p>
              </Card>
            </Col>
            <Col md={4}>
              <Card className="about-card text-center p-4">
                <Star size={40} className="mb-3 text-info" />
                <h5>Unmatched Serenity</h5>
                <p>Escape the chaos and immerse in the calm of nature's embrace.</p>
              </Card>
            </Col>
            <Col md={4}>
              <Card className="about-card text-center p-4">
                <Star size={40} className="mb-3 text-danger" />
                <h5>Easy Booking</h5>
                <p>Quick online booking and instant email confirmation.</p>
              </Card>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Meet the Founder */}
      <Container className="py-5">
        <Row>
          <Col md={8}>
            <h2 className="section-title mb-3">Meet the Founder</h2>
            <p>
              With a team of dedicated professionals and a deep love for Kodaikanal, Elavarasan founded Kabili Holidays to create unforgettable guest experiences. His commitment to excellence and passion for travel ensures that every moment you spend with us is meaningful and memorable.
            </p>
            <p>
              <strong>Need help? Contact us:</strong><br />
              +91 9965113099 or <a href="mailto:kabiliholidays23@gmail.com">kabiliholidays23@gmail.com</a>
            </p>
          </Col>
          <Col md={4} className="text-center">
            <img
              src="/logo.png"
              alt="Kabili Holidays Logo"
              className="rounded-circle mb-2"
              style={{ width: 120, height: 120 }}
            />
            <h5>Elavarasan</h5>
            <p>Founder</p>
          </Col>
        </Row>
      </Container>

      {/* Call to Action */}
      <Container className="cta-bottom text-white py-5 text-center">
        <h3 className="fw-bold mb-2">Escape. Relax. Rejuvenate.</h3>
        <p>Plan your next stay with Kabili Holidays and discover the soul of Kodaikanal.</p>
        <Button variant="light" size="lg" className="rounded-pill fw-bold mt-3" as={Link} to="/rooms">Get Started</Button>
      </Container>
    </div>
  );
};

export default AboutPage;
